module.exports = __webpack_public_path__ + "static/media/icon-exit.709b8640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/icon-exit.svg
// module id = 2379
// module chunks = 0